import React from "react";
import "./TabStrip.scss";
import TabItemData from "../models/TabItemData";
import { later } from "../models/utils";

export function TabStrip(props: {
  items: Array<TabItemData>;
  activeItem: string;
  setActiveItem: (itemId: string) => void;
}) {
  const { items, activeItem, setActiveItem } = props;
  const [visualActiveItem, setVisualActiveItem] = React.useState(activeItem);

  React.useEffect(() => {
    setVisualActiveItem(activeItem);
  }, [activeItem]);

  return (
    <div className="TabStripWrapper">
      <div className="TabStrip">
        {items.map((item) => (
          <div
            key={item.paneId}
            className={`TabStripItem ${visualActiveItem === item.paneId ? "active" : ""}`}
            onClick={async () => {
              setVisualActiveItem(item.paneId);
              later(() => {
                setActiveItem(item.paneId);
              }, 180);
            }}
          >
            {item.title}
          </div>
        ))}
      </div>
    </div>
  );
}
